import {  Component, QueryList, ViewChildren,} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DataService } from '../../../services/data/data.service';

import { FiltersM, typesApex } from '../../../components/models';
import { formatear, } from '../../funciones/funcionesGenerales';
import moment from 'moment';
import { firstValueFrom } from 'rxjs';
import Swal from 'sweetalert2';
import { messages } from '../../funciones/mensajes';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
// Registrar fuentes virtuales
pdfMake.addVirtualFileSystem(pdfFonts);
import { GraficasComponent } from '../../../components/graficas/graficas.component';
import { ConstantesImagenes } from '../../../models/Cuestionarios/codigoimagenes';
import { ComercialService, PERIODICITY, PerspectiveIdentifier } from '../../../services/comercial/comercial.service';
import { Meses } from '../../../models/Formulacion/indicadores-metas/datos';

@Component({
  selector: 'app-perfil',
  templateUrl: './perfil.component.html',
  styleUrl: './perfil.component.css',
})
export class PerfilComponent {
  @ViewChildren(GraficasComponent) grafComp!: QueryList<GraficasComponent>;
  private pdfFile: any;

  public types = typesApex;
  // Variables para los filtros
  sucursales = [];
  consolidado = true;
  filters = {};

  public Filters = FiltersM;
  selectedYears = [];
  selectedMonths: number[] = [0];
  yearsInput: number[] = [0];

  yearsAvailable: any[];
  monthOfYearAvailable: any[];
  monthAvailable: any[];
  yearMonthSelected: string = '';

  /* Greáficas */
  subtitles = '';
  perspectives = [undefined,undefined,undefined,undefined,undefined,undefined];
  // Valores para generar la gráfica 1
  tituloZona1 = '';
  data1 = [];
  labels1 = [];
  axisY1 = [];
  graphics1 = [typesApex.DONUT, typesApex.AREA, typesApex.BAR, typesApex.LINE, typesApex.TABLE];
  zona1 = 1;
  // Valores para generar la gráfica 1
  tituloZona2 = '';
  data2 = [];
  labels2 = [];
  axisY2 = [];
  graphics2 = [typesApex.HEATMAP, typesApex.AREA, typesApex.BAR, typesApex.LINE, typesApex.TABLE];
  zona2 = 2;
  // Valores para generar la gráfica 1
  tituloZona3 = '';
  data3 = [];
  labels3 = [];
  axisY3 = [];
  graphics3 = [typesApex.DONUT, typesApex.AREA, typesApex.BAR, typesApex.LINE, typesApex.TABLE];
  zona3 = 3;
  // Valores para generar la gráfica 1
  tituloZona4 = '';
  data4 = [];
  labels4 = [];
  axisY4 = [];
  graphics4 = [typesApex.DONUT, typesApex.AREA, typesApex.BAR, typesApex.LINE, typesApex.TABLE];
  zona4 = 4;
  // Valores para generar la gráfica 1
  tituloZona5 = '';
  data5 = [];
  labels5 = [];
  axisY5 = [];
  graphics5 = [typesApex.DONUT, typesApex.AREA, typesApex.BAR, typesApex.LINE, typesApex.TABLE];
  zona5 = 5;
  // Valores para generar la gráfica 1
  tituloZona6 = '';
  data6 = [];
  labels6 = [];
  axisY6 = [];
  graphics6 = [typesApex.DONUT, typesApex.AREA, typesApex.BAR, typesApex.LINE, typesApex.TABLE];
  zona6 = 6;

  private token;
  Perspectives = [
    {identifier: PerspectiveIdentifier.GENDER, name: 'Género'},
    {identifier: PerspectiveIdentifier.AGE_RANGE, name: 'Edad'},
    {identifier: PerspectiveIdentifier.GENERATION, name: 'Generación'},
    {identifier: PerspectiveIdentifier.MARITAL_STATUS, name: 'Estado civil'},
    {identifier: PerspectiveIdentifier.PROFESSION, name: 'Ocupación'},
    {identifier: PerspectiveIdentifier.ECONOMIC_ACTIVITY, name: 'Actividad Economica'},
    {identifier: PerspectiveIdentifier.EDUCATION_LEVEL, name: 'Nivel educación'},
    {identifier: PerspectiveIdentifier.MUNICIPALITY, name: 'Munucipio'},
    {identifier: PerspectiveIdentifier.MEMBER_STATUS, name: 'Estatus'},
    {identifier: PerspectiveIdentifier.BRANCH_OFFICE, name: 'Sucursales'},
  ]

  constructor(
    public dataService: DataService,
    public translate: TranslateService,
    private readonly comercialService: ComercialService,
  ) {
    formatear.momentAbrev();
    this.getPeriodos();
  }
  // Obtención de datos
  private async getPeriodos(){

    // this.token = await firstValueFrom(this.comercialService.loginAleema());

    for(var i = 0; i<10; i++){
      this.sucursales.push({
        name: `Sucursal-${i+1}`,
        check: false
      });
    }

    const start = moment('2026-02-01');
    const end = moment('2026-03-30');
    var auxYear = [], auxMounts = [], year = undefined;
    while(start.isSameOrBefore(end)){
      const exYear = auxYear.find(y => y.anio === start.year());
      if(!exYear){
        // year = start.year();
        auxYear.push({
          anio: start.year(),
          name: `${start.year()}`,
          check: false,
        });
      }
      auxMounts.push({
        name: start.format('MMM').toLowerCase(),
        check: false,
        an: start.year(),
        periodo: start.format('MMM-YY').toLowerCase(),
      });
      start.add(1, 'month');
    }
    this.yearsAvailable = auxYear;
    this.yearsAvailable[this.yearsAvailable.length-1].check = true;
    this.monthAvailable = auxMounts;
    const months = this.monthAvailable.filter( y => y.an === auxYear[auxYear.length-1].anio );
    months[months.length-1].check = true;
    this.monthOfYearAvailable = months;

    this.getData();
  }
  private getData() {
    this.setZonaData({
      perspectiveIndex: 0,
      dataKey: 'data1',
      labelsKey: 'labels1',
      tituloKey: 'tituloZona1',
      axisYKey: 'axisY1',
      name: 'Género',
    });

    this.setZonaData({
      perspectiveIndex: 1,
      dataKey: 'data2',
      labelsKey: 'labels2',
      tituloKey: 'tituloZona2',
      axisYKey: 'axisY2',
      name: 'Edad',
    });

    this.setZonaData({
      perspectiveIndex: 2,
      dataKey: 'data3',
      labelsKey: 'labels3',
      tituloKey: 'tituloZona3',
      axisYKey: 'axisY3',
      name: 'Generación',
    });

    this.setZonaData({
      perspectiveIndex: 3,
      dataKey: 'data4',
      labelsKey: 'labels4',
      tituloKey: 'tituloZona4',
      axisYKey: 'axisY4',
      name: 'Nivel educación',
    });

    this.setZonaData({
      perspectiveIndex: 4,
      dataKey: 'data5',
      labelsKey: 'labels5',
      tituloKey: 'tituloZona5',
      axisYKey: 'axisY5',
      name: 'Ocupación',
    });

    this.setZonaData({
      perspectiveIndex: 5,
      dataKey: 'data6',
      labelsKey: 'labels6',
      tituloKey: 'tituloZona6',
      axisYKey: 'axisY6',
      name: 'Estado civil',
    });

    this.getSubtitles();
  }
  private async setZonaData(config: {
    perspectiveIndex: number;
    dataKey: 'data1' | 'data2' | 'data3' | 'data4' | 'data5' | 'data6';
    labelsKey: 'labels1' | 'labels2' | 'labels3' | 'labels4' | 'labels5' | 'labels6';
    tituloKey: 'tituloZona1' | 'tituloZona2' | 'tituloZona3' | 'tituloZona4' | 'tituloZona5' | 'tituloZona6';
    axisYKey: 'axisY1' | 'axisY2' | 'axisY3' | 'axisY4' | 'axisY5' | 'axisY6';
    name: string;
  }) {
    if ( this.perspectives[config.perspectiveIndex] ) return;
    const perspective = this.Perspectives.find(p => config.name === p.name);
    if(!perspective){
      return;
    }

    const filter = {} 
    this.perspectives.slice(0, config.perspectiveIndex).forEach( f => {
      if(f){
        const per: PerspectiveIdentifier = this.Perspectives.find(p => f.filter === p.name).identifier;
        filter[per] = [Number(f.code)]
      }
    });

    const per = this.getPeriodo();

    const data = await firstValueFrom(
      this.comercialService.getCuentas({
        perspective: perspective.identifier,
        period: per,
        granularity: PERIODICITY.MONTH,
        filters: filter
      })
    ); 

    const codes: number[] = [];
    const labels: string[] = [];
    const values: number[] = [];

    if(data['results'].length > 30){
      data['results'] = data['results'].slice(0, 30)
    }

    data['results'].forEach(item => {
      codes.push(item.code);
      labels.push(item.description);
      values.push(item.measures.activeCount);
    }); 
    

    this[config.dataKey] = [{
      name: config.name,
      data: values,
      extra: codes
    }];

    this[config.labelsKey] = labels;
    this[config.tituloKey] = config.name;
    this[config.axisYKey] = [config.name];
  }
  private async getSubtitles(){
    this.subtitles = '';
    for(const per of this.perspectives){
      if(per){
        this.subtitles += ` ${per.name} |`;
      }
    }

    const an = this.yearsAvailable.find(y => y.check = true).name.substring(2,4);
    const mes = this.monthOfYearAvailable.find(m => m.check === true).name
    
    this.subtitles += ` ${an} | ${mes}`;

    if(this.consolidado){
      const traduccion = await firstValueFrom(
        this.translate.get('filtros.consolidado')
      );
      this.subtitles += ` | ${traduccion}`;
    }else{
      for(const suc of this.sucursales){
        if(suc.check){
          this.subtitles += ` | ${suc.name}`;
        }
      }
    }
  }
  private getPeriodo(){
    const an = this.yearsAvailable.find(y => y.check = true).name;
    const mes = Meses.getMesesNum(this.monthOfYearAvailable.find(m => m.check === true).name)

    return `${an}-${mes}`;
  }
  // Eventos click
  clickGrafic(event: any, zona: number) {
    // if(zona-1 === 0 || this.perspectives[zona-2] !== ''){
      const dataKey = ['data1', 'data2', 'data3', 'data4', 'data5', 'data6']
      this.perspectives.forEach( (p, i) => {
        if(i === zona-1){
          this.perspectives[i] = {name: event.name, code: this[dataKey[zona-1]][0].extra[event.posValue], filter: this[dataKey[zona-1]][0].name};
        }else if( i >= zona ){
          this.perspectives[i] = undefined;
        }
      });
      this.getData();
    // }
  }
  yearChange(year){
    for(const y of this.yearsAvailable){
      if(y.anio === year.anio){
        y.check = true;
        const months = this.monthAvailable.filter( ye => ye.an === year.anio );
        months[months.length-1].check = true;
        this.monthOfYearAvailable = months;
      }else{
        y.check = false;
      }
    }
    this.getData();
  }
  monthChange(mes){
    for(const m of this.monthOfYearAvailable){
      if(m.name === mes.name){
        m.check = true;
      }else{
        m.check = false;
      }
    }
    this.getData();
  }
  agencyChange(sucClick: any){
    for(const suc of this.sucursales){
      if(sucClick !== 'consolidado' && suc.name === sucClick.name){
        suc.check = true;
      }else{
        suc.check = false;
      }
    }
    if(sucClick === 'consolidado'){
      this.consolidado = !this.consolidado;
    }else{
      this.consolidado = false;
    }
    this.getData();
  }
  resetFilters(){
    this.perspectives = ['','','','','',''];
    this.yearsAvailable[this.yearsAvailable.length-1].check = true;
    const months = this.monthAvailable.filter( y => y.an === this.yearsAvailable[this.yearsAvailable.length-1].anio );
    months[months.length-1].check = true;
    this.monthOfYearAvailable = months;
    this.getData();
  }
  //Exportación de PDF All
  async exportarPDF(){
    try{
      messages.messageSaving(this.translate.instant('acciones.descarga'),this.translate.instant('acciones.espera'))

      const fechaPiePag = new Date().toLocaleDateString('es-MX', {month: '2-digit',day: '2-digit',year: '2-digit',});
      const horaPiePag = new Date().toLocaleTimeString('es-MX');
      const currentUser = this.dataService.user;

      const docPDF = {
        pageSize: 'FOLIO',
        images: {
          logoAleema: ConstantesImagenes.fondoblanco,
        },
        footer: function (currentPage, pageCount){
          if(currentPage == 1){
            return null;
          }
          if(currentPage === pageCount){
            return{
              columns: [
                {
                  image: 'logoAleema',
                  width: 70,
                  margin: [30, -1, 30, 0],
                },
                {
                  text: `${currentUser}  |  ${fechaPiePag}  |  ${horaPiePag}`,
                  alignment: 'center',
                  width: '*',
                  color: '#808080',
                  fontSize: 10,
                },

                {
                  text: (currentPage - 1).toString(),
                  color: '#808080',
                  fontSize: 10,
                  width: 'auto',
                  margin: [10, -1, 30, 0],
                },
              ]
            }
          }else{
            return{
              text: {
                  text: (currentPage - 1).toString(),
                  alignment: 'right',
                  color: '#808080',
                  fontSize: 10,
                  width: 'auto',
                },margin: [10, -1, 30, 0],
            }
          }
        },
        content: [
          await this.generateZonaPDF(this.zona1),
          await this.generateZonaPDF(this.zona2),
          await this.generateZonaPDF(this.zona3),
          await this.generateZonaPDF(this.zona4),
          await this.generateZonaPDF(this.zona5),
          await this.generateZonaPDF(this.zona6),
        ]
      }

      var reportName = 'Reporte general';
      const pdf = pdfMake.createPdf(docPDF);
      
      pdf.download(reportName);
      const blob = await pdf.getBlob();
      this.pdfFile = blob;

      Swal.close();
      messages.succesMessageGraph(this.translate.instant('acciones.desExito'))
    }catch(error){
      Swal.close();
      Swal.fire({title: this.translate.instant('cues.reporte.errorReporte'), timer: 10000});
    }
  }
  async generateZonaPDF(zonaE){
    const comp = this.grafComp.find(g => g.zona === zonaE);
    var img = undefined;
    var table = undefined;
    if(comp.type !== typesApex.TABLE){
      img = await comp.exportImgBlob();
    }
    table = await comp.exportTablePDF();

    var cont = [
      comp.exportTitles(),
      // table !== undefined ? {
      //   text: 'Tabla'
      // } : { text: '' },
      table !== undefined ? table : { text: '' },
      // img !== undefined ? {
      //   text: 'Gráfica'
      // } : { text: '' },
      img !== undefined ? img : { text: '' }
    ];
    return cont;
  }
}


